import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ColumnOption, ColumnUIKey } from "../../../constants/schema.js";
import { bHas } from "../../../utils/bit.js";
//#region src/engine/modules/table-column/keys.ts
function syncPrimaryKeys({ collections }) {
	for (const column of query(collections).collection("tableColumnEntities").selectAll()) {
		const value = bHas(column.options, ColumnOption.primaryKey);
		if (value === bHas(column.ui.keys, ColumnUIKey.primaryKey)) continue;
		column.ui.keys = value ? column.ui.keys | ColumnUIKey.primaryKey : column.ui.keys & ~ColumnUIKey.primaryKey;
	}
}
function validateForeignKeys({ doc, collections }) {
	const endColumnIds = /* @__PURE__ */ new Map();
	const relationships = query(collections).collection("relationshipEntities").selectByIds(doc.relationshipIds);
	for (const { end } of relationships) {
		const ids = endColumnIds.get(end.tableId) ?? /* @__PURE__ */ new Set();
		end.columnIds.forEach((id) => ids.add(id));
		endColumnIds.set(end.tableId, ids);
	}
	const tableIdOf = /* @__PURE__ */ new Map();
	for (const table of query(collections).collection("tableEntities").selectByIds(doc.tableIds)) table.columnIds.forEach((id) => tableIdOf.set(id, table.id));
	for (const column of query(collections).collection("tableColumnEntities").selectAll()) {
		const tableId = tableIdOf.get(column.id);
		const value = tableId !== void 0 && (endColumnIds.get(tableId)?.has(column.id) ?? false);
		if (value === bHas(column.ui.keys, ColumnUIKey.foreignKey)) continue;
		column.ui.keys = value ? column.ui.keys | ColumnUIKey.foreignKey : column.ui.keys & ~ColumnUIKey.foreignKey;
	}
}
//#endregion
export { syncPrimaryKeys, validateForeignKeys };
